import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@progress/kendo-react-buttons'
import { InlineWidget, useCalendlyEventListener } from 'react-calendly'
import { useRef, useEffect } from 'react'
import { useGlobalCtx } from '../../../Context/GlobalContext'
import { useRecruitDispatchCtx } from '../../../Context/RecruitContext'
import { useSurveyCtx } from '../../../Context/SurveyContext'
import { ScheduleState, UserResponse } from '../../../Common'
import {
  SurveyEngine_Models_RecruitResponse,
  SurveyService_Application_Commands_SubmitCalendarSchedule_CalendarURLs,
} from '../../../api'
import parse from 'html-react-parser'

interface calendlyProps {
  id: number
  studyName: string
  message: string
  calendarRecruitUrl: string
  postSurvey: boolean
  getNextQuestionCommand: (
    surveySID: string,
    payLoad: UserResponse,
    isFirstTime?: boolean
  ) => void
  getSubmitCalendarSchedule: (
    panelistId: number,
    StudyId: number,
    payload: SurveyService_Application_Commands_SubmitCalendarSchedule_CalendarURLs
  ) => void
}

export const Calendly = (props: calendlyProps) => {
  const calendlyRef = useRef<HTMLDivElement>(null)
  const globalCtx = useGlobalCtx()
  const surveyCtx = useSurveyCtx()
  const recruitCtxDispatch = useRecruitDispatchCtx()
  const panelist: string[] =
    surveyCtx.StartSurvey.panelistName?.split(' ') ?? []
  useEffect(() => {
    calendlyRef.current?.focus()
  }, [props])

  useCalendlyEventListener({
    onDateAndTimeSelected: (e) => console.log(e),
    onEventTypeViewed: () => console.log('onEventTypeViewed'),
    onEventScheduled: (e) => {
      console.log(`Invitee ${e?.data.payload.invitee.uri}`)
      console.log(`Event ${e?.data.payload.event.uri}`)
      let recruitResponse: SurveyEngine_Models_RecruitResponse = {
        commandIndex: surveyCtx.NextQuestion.commandIndex,
        commandType: surveyCtx.NextQuestion.commandType,
        declined: false,
        eventUrl: e?.data.payload.event.uri,
        inviteeUrl: e?.data.payload.invitee.uri,
        sessionIds: [],
      }
      if (!props.postSurvey) {
        props.getNextQuestionCommand(surveyCtx.StartSurvey.surveyInstanceId!, [
          recruitResponse,
        ])
      } else {
        let eventURLs: SurveyService_Application_Commands_SubmitCalendarSchedule_CalendarURLs =
          {
            eventURL: e?.data.payload.event.uri,
            inviteeURL: e?.data.payload.invitee.uri,
          }
        props.getSubmitCalendarSchedule(
          globalCtx.PanelistId!,
          globalCtx.StudyId!,
          eventURLs
        )
      }
    },
  })

  const onDecline = () => {
    recruitCtxDispatch({ type: 'ScheduleState', value: ScheduleState.DECLINE })
  }

  return (
    <>
      <div
        tabIndex={0}
        ref={calendlyRef}
        id="studyHeading"
        className="flex flex-col"
      >
        <div className="font-semibold pb-2">
          <FontAwesomeIcon icon={faCalendarAlt} size="2x" />
          <span className="ml-2 text-3xl">
            {globalCtx.LangResources.recruitMsg.selection.heading}
          </span>
        </div>
        <div
          id={`studyName_${props.id}`}
          className="pb-2 lg:text-lg md:text-base text-xs font-semibold"
        >
          {globalCtx.LangResources.recruitMsg.studyMsg.replace(
            '{StudyName}',
            props.studyName
          )}
        </div>
        <div id={`msg_${props.id}`} className="theme-session-message">
          {parse(props.message.replace(/""/g, '"'))}
        </div>
      </div>
      <div className="h-full">
        <InlineWidget
          styles={{ height: '105vh' }}
          url={props.calendarRecruitUrl as string}
          prefill={{
            firstName: panelist.length > 0 ? panelist[0] : '',
            lastName: panelist.length > 1 ? panelist[1] : '',
            name: surveyCtx.StartSurvey.panelistName ?? '',
            email: surveyCtx.StartSurvey.panelistEmail ?? '',
          }}
          pageSettings={{ hideLandingPageDetails: true }}
          utm={{
            utmCampaign: `StudyID:${
              props.postSurvey
                ? globalCtx.StudyId
                : surveyCtx.StartSurvey.studyId
            }`,
            utmContent: 'Survey',
            utmMedium: 'SurveyEngineV2',
            utmSource: `PanelistID:${
              props.postSurvey
                ? globalCtx.PanelistId
                : surveyCtx.StartSurvey.panelistId
            }`,
            utmTerm: 'Spring',
          }}
        />
        <div
          className={
            'theme-btn-continer min-h-[5vh] md:flex flex-row-reverse justify-between pt-8 pb-2 mt-8'
          }
        >
          <div className="mb-8 md:basis-1 lg:basis-1/4">
            <div className="flex flex-col">
              <Button
                id="declineButton"
                className="theme-btn-cancel w-full"
                data-testid="decline-btn"
                onClick={onDecline}
                aria-labelledby="declineMsg declineButton"
              >
                {globalCtx.LangResources.recruitMsg.declineButton}
              </Button>
              <div id="declineMsg" className="text-center text-sm">
                {globalCtx.LangResources.recruitMsg.declineButtonMsg}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
